<template>
  <section class="row">
    <div class="col-xs-12">
      <table class="table table-striped" v-if="items.length">
        <thead>
          <tr>
            <th>&nbsp;</th>
            <th>Next Pickup</th>
            <th># Related Orders</th>
            <th>Total Weight</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in items"
            :item="item"
            is="item-group"
            track-by="product.id"
          ></tr>
        </tbody>
      </table>

      <div v-if="!items.length" class="text-center no-orders">
        <img src="../../assets/images/logo-sm.svg" /><br />
        There are no items to group process.
      </div>
    </div>
  </section>
</template>

<script>
import { Api, IO } from 'src/utilities';
import Stash from 'src/stash';
import ItemGroup from '../ItemGroup';
import InteractsWithState from 'mixins/InteractsWithState';

const refresh = () =>
  Api.get('item-groups', { channel: 'foreground' })
    .then(response => Stash.setItemGroups(response.data.data))
    .catch(Api.handleVisibilityError);

export default {
  mixins: [InteractsWithState],

  route: {
    activate: refresh,
  },

  ready() {
    // any time an order is updated, created, modified, etc... this list of grouped
    // items should reload.
    IO.on('order', payload => {
      const whitelist = ['fulfilled', 'canceled', 'placed', 'updated'];

      if (whitelist.includes(payload.event)) {
        refresh();
      }
    });
  },

  computed: {
    items() {
      return this.state.item_groups;
    },
  },

  components: { ItemGroup },
};
</script>



// WEBPACK FOOTER //
// ItemGroups.vue?73e3f244